import { Injectable } from '@angular/core';
import { ITokenStorageRepository } from '../../domain/repositories/token-storage.repository';

@Injectable()
export class SessionTokenStorageRepository implements ITokenStorageRepository {
  private readonly TOKEN_KEY = 'tokenActive';

  saveToken(token: string): void {
    sessionStorage.setItem(this.TOKEN_KEY, token);
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.TOKEN_KEY);
  }

  removeToken(): void {
    sessionStorage.removeItem(this.TOKEN_KEY);
  }

  hasValidToken(): boolean {
    const token = this.getToken();
    return token !== null && token.trim() !== '';
  }
}
